<template>
	<div class="sidebar-nav-box">
		<ul class="sidebar-nav">
			<li class="sidebar-item" :class="{ active: selectedNav === item.routeName }" v-for="(item, index) in nav_list" :key="item.id" @click="selectItem(item)">
				<router-link :to="item.link">
					<div class="right_text_box">
						<img class="item_icon" :src="item.icon" :alt="'TOZO Community ' + item.title + ' icon'"/>
						<h2 class="item_title">{{ item.title }}</h2>
					</div>
					<div class="left_icon"><i class="el-icon-arrow-right"></i></div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
// import TopNavbar from './components/TopNavbar.vue'

// let img_url = process.env.VUE_APP_API_URL_IMG
let img_url = "https://s3-us-tozo-test-wr.tozostore.com/Admin/app30/img/"

export default {
	name: 'sidebar',
	// components: { TopNavbar },
	
	data() {
		return {
			selectedNav: "",
			nav_list:[
				{
					id: 1,
					name: "首页",
					title: this.$t('homePage.nav.Home'),
					routeName: "home",
					link: "/",
					icon: img_url + "202501081222474747_1736338967vqmjcuZ8SGXEfGrJ.png",
					// icon: img_url + "assets/icon/home_page.png",
				},
				{
					id: 2,
					name: "关注列表",
					title: this.$t('homePage.nav.Followers_list'),
					routeName: "follow-list",
					link: "/follow-list",
					icon: img_url + "202501081222474747_1736338967BlhBeeS9WIPf3Cwk.png",
					// icon: img_url + "assets/icon/follow_list.png",
				},
				{
					id: 3,
					name: "粉丝主页",
					title: this.$t('homePage.nav.Fans_list'),
					routeName: "fans-list",
					link: "/fans-list",
					icon: img_url + "202501081222474747_1736338967g7vw2cwkqe0tx0Ua.png",
					// icon: img_url + "assets/icon/fan_list.png",
				},
				{
					id: 4,
					name: "个人主页",
					title: this.$t('homePage.nav.Personal'),
					routeName: "user-profile",
					link: "/user-profile",
					icon: img_url + "202501081226191919_173633917936TU3VVF0qfsjhQu.png",
					// icon: img_url + "assets/icon/personal.png",
				},
				{
					id: 5,
					name: "消息页",
					title: this.$t('homePage.nav.Messages'),
					routeName: "messages",
					link: "/messages",
					icon: img_url + "202501081222474747_1736338967UexlTg5a48vkEt1w.png",
					// icon: img_url + "assets/icon/news.png",
				}
			]
		}
	},
	
	// 监听
	watch: {
		'$route': {
		   handler (newValue, oldValue) {
				this.if_routeName(newValue)
		   },
		   deep: true
		}
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  this.get_selectedNav()
  },
  
  methods:{
	// 路由变化判断是否有选择的路由
	if_routeName(newValue){
		// let arr = this.nav_list.filter(item => item.routeName === newValue.name);
		let obj
		this.nav_list.forEach((item) =>{
			if(item.routeName === newValue.name){
				obj = item
			}
		})
		if(obj){
			this.selectedNav = obj.routeName;
			this.setRouteName(this.selectedNav)
			return true
		}else{
			this.setRouteName()
			return false
		}
	},
	  
	// 点击菜单选中状态
	selectItem(item) {
	   this.selectedNav = item.routeName; // 更新选中项的索引
		this.close_bulletFrame()
	},
	
	// 获取刷新之后的路由
	get_selectedNav(){
		if(this.if_routeName({name: this.$route.name})){
			this.selectedNav = this.$route.name;
			this.setRouteName(this.selectedNav)
		}else{
			this.setRouteName()
		}
	},
	
	setRouteName(name){
		if(name){
			this.selectedNav = name;
			localStorage.setItem('routeName', name)
		}else{
			if(!this.selectedNav){
				let routeName = localStorage.getItem('routeName')
				this.selectedNav = routeName ? routeName : 'home'
			}
		}
	},
	
	close_bulletFrame(){
		this.$emit("close_bulletFrame_fun")
	}
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.sidebar-nav-box {
		width: 100%;
	}

	.sidebar-nav {
	  list-style-type: none;
		width: 100%;
		padding: 10px; 
		background-color: #ffffff;
		border-radius: 8px;
	}

	.sidebar-nav li {
	  margin: 10px 0;
	}

	.sidebar-nav a {
	  text-decoration: none;
	  color: #666666;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  padding: 5px 0px;
	  border-bottom: 1px transparent solid;
	}
	.sidebar-nav a:hover {
		color: #333333;
	  /* text-decoration: underline; */
	  /* border-bottom: 1px #666666 solid; */
	}
	.sidebar-item.active .left_icon{
		color: #000000;
	}
	.sidebar-item.active .item_title{
		color: #000000;
		font-weight: 600;
	}
	.sidebar-nav a.router-link-active {
	  /* color: #333333; */
	  /* font-weight: bold; */
	  /* border-bottom: 1px #333333 solid; */
	}
	.right_text_box{
		display: flex;
		width: calc(100% - 20px);
	}
	.item_icon{
		width: 100%;
		max-width: 23px;
		height: 23px;
	}
	.item_title{
		display: flex;
		align-items: center;
		margin-left: 15px;
		font-family: Poppins, Poppins;
		font-weight: 400;
		font-size: 14px;
		color: #505050;
		line-height: 14px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	.left_icon{
		width: 20px;
		text-align: right;
	}
</style>
